"use client";

import React, { useState } from "react";
import Link from "next/link"

interface ButtonProps {
    text?: string;  
    icon?: React.ReactNode;
    iconPostiton?: "right";
    hoverIcon?: React.ReactNode;
    href?: string;
    type: string;
    size?: "big";
    fontSize?: "big";
    mobileFull?: string;
    mobiletextSmall?: string;
    notuppercase?: string;
    isvideoBtn?: string;
    onClick?: () => void;
}

const Button: React.FC<ButtonProps> = ({ text, icon, hoverIcon, iconPostiton, type, href, size, fontSize, mobileFull, mobiletextSmall, notuppercase, isvideoBtn, onClick }) => {
    const [isHovered, setIsHovered] = useState(false);

    const buttonClass = `  max-[576px]:px-[12px]
    ${fontSize === "big" ? "text-base" : "text-sm"} 
    ${text ? "py-3" : "py-4"} py-3 px-4 rounded-40 font-semibold leading-[143%]  flex items-center duration-300
    ${type === "primary" ? "bg-yellow-500 text-black hover:bg-yellow-300" : ""}
    ${type === "secondary" ? "bg-white text-grey-900 border-[1.5px] border-[rgba(255,176,0,0.3)] hover:bg-yellow-50 hover:text-yellow-700 hover:border-[rgba(255,176,0,0.8)]" : ""}
    ${type === "third" ? "bg-yellow-100 text-violet-400" : ""}
    ${size === "big" ? "min-w-[264px] justify-center" : ""} 
    ${mobileFull === "yes" ? "max-[767px]:w-full justify-center" : ""} 
    ${mobiletextSmall === "yes" ? "max-[576px]:text-[10px]" : ""} 
    ${notuppercase === "yes" ? "capitalize" : "uppercase"} 
    ${isvideoBtn === "yes" ? "max-[576px]:p-[12px]" : "uppercase"} 
    `;

    const sharedContent = (
        <>
            {iconPostiton !== "right" && (isHovered && hoverIcon ? (
                <span className={text ? "mr-2" : ""}>{hoverIcon}</span>
            ) : (
                icon && <span className={text ? "mr-2" : ""}>{icon}</span>
            ))}
            {text}
            {iconPostiton === "right" && (isHovered && hoverIcon ? (
                <span className={text ? "ml-2" : ""}>{hoverIcon}</span>
            ) : (
                icon && <span className={text ? "ml-2" : ""}>{icon}</span>
            ))}
        </>
    );

    return href ? (
        <Link
            href={`/${href}`}
            className={buttonClass}
            onClick={onClick}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
        >
            {sharedContent}
        </Link>
    ) : (
        <button
            className={buttonClass}
            onClick={onClick}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
        >
            {sharedContent}
        </button>
    );
};

export default Button;
